import { useToast, useAxiosPrivate } from 'shared/hooks'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { queryKeys } from 'config/queryKeys'

export const useDeleteRentalMutation = (closeDeleteModal: () => void) => {
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const { t } = useTranslation()

	const { mutate: rentalDeleteMutation } = useMutation({
		mutationFn: (idToBeRemoved: number) => {
			// TODO: change to apiRoutes
			return axiosPrivate.delete(`/rentals/${idToBeRemoved}/`)
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Rental deleted')
			})()

			queryClient.invalidateQueries({ queryKey: queryKeys.rentals.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			closeDeleteModal()
		}
	})

	return {
		rentalDeleteMutation
	}
}
